import { BqCheckbox, BqOption } from '@beeq/react'
import styled from 'styled-components'

export const StyledBqCheckbox = styled(BqCheckbox)`
  pointer-events: none;
  margin-left: ${({ level }) => {
        const spacingREM = getComputedStyle(document.documentElement).getPropertyValue('--bq-spacing-m')
        const spacingNumber = parseInt(spacingREM.split('rem')[0])

        return level * spacingNumber + 'rem'
    }};
`

export const StyledBqOption = styled(BqOption)`
  &::part(label){
    display: flex;
    align-items: center;
  }
`
